import theme from 'src/theme';
import styled from 'styled-components';

type WarningProps = {
    inline?: boolean;
};

export const WarningText = styled.div<WarningProps>`
    color: ${theme.legacyColors.orange};
    margin-top:  ${(props) => (!props.inline ? '1rem' : '')};
`;
